import React from "react";

const MaleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="male_icon"
      data-name="male"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 2.5V4.16667H14.6583L11.8417 6.98333C10.9417 6.34167 9.85833 5.83333 8.33333 5.83333C4.65833 5.83333 1.66667 8.825 1.66667 12.5C1.66667 16.175 4.65833 19.1667 8.33333 19.1667C12.0083 19.1667 15 16.175 15 12.5C15 10.975 14.4917 9.89167 13.85 8.99167L16.6667 6.175V9.16667H18.3333V2.5H11.6667ZM8.33333 17.5C5.575 17.5 3.33333 15.2583 3.33333 12.5C3.33333 9.74167 5.575 7.5 8.33333 7.5C11.0917 7.5 13.3333 9.74167 13.3333 12.5C13.3333 15.2583 11.0917 17.5 8.33333 17.5Z"
        fill={props.fill || "#0E426D"}
      />
    </svg>
  );
};

export default MaleIcon;


